import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Button, Icon } from "../../../components/Component";
import Required from "./Required";

const MultiDropImage = ({ maxSize, fileType, setValue, trigger, watch, errors, title, name, register, required }) => {
  // handles ondrop function of dropzone
  const handleDropChange = (acceptedFiles, set, name) => {
    set(
      name,
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
    trigger(name)
  };
  useEffect(() => {
    register(name, {
      validate: (files) => (required ? (files && files.length > 0) || `${title || "This field"} is required` : true),
    });
  }, [register, name, required, title]);
  console.log("errors", errors);
  return (
    <>

      <div className="form-group my-2">
        {title && (
          <label className="form-label">
            {title} {required && <Required />}
          </label>
        )}

        <Dropzone
          onDrop={(acceptedFiles) => handleDropChange(acceptedFiles, setValue, name)}
          maxSize={4194304}
          accept={[".jpg", ".png", ".svg"]}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()} className="dropzone upload-zone dz-clickable">
                <input {...getInputProps()} />

                {/* Upload Placeholder */}
                {(!watch(name) || watch(name)?.length === 0) && (
                  <div className="dz-message">
                    <span className="dz-message-text">Drag and drop file</span>
                    <span className="dz-message-or">or</span>
                    <Button type="button" color="primary">
                      SELECT
                    </Button>
                  </div>
                )}
                {/* Image Preview */}
                {watch(name)?.map((file, index) => (
                  <div
                    key={file.name}
                    className="dz-preview dz-image-preview dz-complete position-relative"
                  >
                    <Button
                      className={""}
                      size={"xs"}
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        const updatedFiles = watch(name).filter((_, i) => i !== index);
                        setValue(name, updatedFiles, { shouldValidate: true });
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon color="danger" name="trash" style={{ color: "crimson" }} />
                    </Button>
                    <div className="dz-image">
                      <img src={file.preview} alt="preview" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Validation Error */}
              {errors[name] && (
                <span
                  className="invalid text-danger fst-italic"
                  style={{ fontSize: "11px" }}
                >
                  {errors[name]?.message}
                </span>
              )}
            </section>
          )}
        </Dropzone>
      </div>

    </>
  );
};

export default MultiDropImage;
